export const linkVariants = {
  grayInitial: "grayInitial",
  yellowInitial: "yellowInitial",
  whiteInitial: "whiteInitial",
};
